import script from "./InfoAlumno.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoAlumno.vue?vue&type=script&setup=true&lang=js"

import "./InfoAlumno.vue?vue&type=style&index=0&id=6f281236&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f281236"]])

export default __exports__